import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap'
import CardOnlineActivity from '../components/CardOnlineActivity'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";


const ActiveActivity = props => {

    const [countItem, setCountItem] = useState(0);
    let onlineActivityStatus = false
    let onlineActivityId = false

    useEffect(() => {
        try {
            let filter = {};
            const roomId = AuthService.getCurrentUser() && AuthService.getCurrentUser().room ? AuthService.getCurrentUser().room.id : ''
            UserService.getRoomDetail(roomId).then((response) => {
                filter.roomId = roomId;
                filter = {
                    'status': 'RUNNING',
                    'domain': AuthService.getCurrentUser().domain.name,
                    'roomId': roomId,
                    'year': response.data.data.year,
                    'term': response.data.data.term
                }
            }).then(() => {
                UserService.getActivities(filter).then((response) => {
                    if (response.data.status.code === 'SUCCESS') {
                        setCountItem(response.data.total)
                        if (response.data.total > 0 && AuthService.getUserRole() === 'student') {
                            onlineActivityStatus = true
                            onlineActivityId = response.data.data[0].topic.id
                            props.onChange({ 'backgroundColor': 'bg-light-blue' })
                        } else {
                            onlineActivityStatus = false
                            onlineActivityId = ''
                            props.onChange({ 'backgroundColor': 'bg-lightness2-blue' })
                        }
                    }
                });
            });
            sseLoad()
        } catch (error) {

        }
    }, []);

    let sseLoad = () => {
        const roomId = (AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.id) ? AuthService.getCurrentUser().room.id : ''
        if (AuthService.getUserRole() === 'student' && roomId) {
            const sse1 = new EventSource(`${process.env.REACT_APP_API_ENDPOINT}/sse/rooms/${roomId}/active-activities`);
            sse1.onmessage = e => setTimeout(() => {
                const data = JSON.parse(e.data)
                const sseStatus = data.status === "RUNNING" ? true : false
                const sseAId = data.topic && data.topic.id ? data.topic.id : ''
                console.log('sseStatus', sseStatus)
                console.log('onlineActivityStatus', onlineActivityStatus)
                console.log(sseAId)
                console.log(onlineActivityId)
                if (
                    (sseStatus !== onlineActivityStatus)
                    ||
                    (sseAId !== onlineActivityId)
                ) {
                    window.location.reload()
                }
            }, 5000);
        }
    }

    if (AuthService.getUserRole() === 'student' && countItem > 0) {
        return (
            <div className="active-activity-main">
                <Row>
                    <div className="text-center w-100 py-3 px-3">
                        <h2 className="pb-0 font-sarabun-bold">กิจกรรมที่กำลังดำเนินอยู่</h2>
                        <CardOnlineActivity page="home" hideDate="0" />
                    </div>
                </Row>
            </div>
        )
    } else if (false && AuthService.getUserRole() === 'student' && countItem === 0) {
        return (
            <div class="text-center py-2 m-auto text-white">
                <h3 class="font-sarabun font-weight-600 my-5 ">ไม่มีกิจกรรม</h3>
            </div>
        )
    } else {
        return (
            <div>
            </div>
        )
    }
}

export default ActiveActivity